import { Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useStore } from "zustand";
import type { ZoneType } from "@designboticteam/kolega-3d";
import { useEngineApi } from "@/engine";

const ZONE_TYPE_OPTIONS: Array<{ value: ZoneType; label: string }> = [
	{ label: "Check zone", value: "CheckZone" },
	{ label: "Building zone", value: "BuildingZone" },
	{ label: "Excluded zone", value: "ExcludedZone" },
];

type Props = {
	value: ZoneType;
	onChange: (zoneType: ZoneType) => void;
};

const ZoneTypeSelector: React.FC<Props> = ({ value, onChange }) => {
	const api = useEngineApi();
	const validationStatus = useStore(api.kolega3D.store, (store) => store.validationStatus);

	return (
		<Stack direction="column">
			<Typography variant="caption">Zone type</Typography>
			<ToggleButtonGroup
				exclusive
				fullWidth
				value={value}
				onChange={(_, nextValue: ZoneType | null) => {
					if (nextValue !== null) {
						onChange(nextValue);
					}
				}}
			>
				{ZONE_TYPE_OPTIONS.map(({ label, value }) => (
					<ToggleButton key={value} value={value} disabled={value !== "CheckZone" && validationStatus.hasCheckZone === false}>
						<Typography variant="caption" sx={{ textTransform: "none" }}>
							{label}
						</Typography>
					</ToggleButton>
				))}
			</ToggleButtonGroup>
		</Stack>
	);
};

export { ZoneTypeSelector };
